<template>
	<div class="doc">
		<slot></slot>
	</div>
</template>

<script>
	export default {
		name: 'bsf-doc',
		components: {},
		props: {},
		data() {
			return {}
		},
		mounted: function() {
			this.$nextTick(function() {})
		},
		computed: {}

	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
</style>


// WEBPACK FOOTER //
// doc.vue?c0ccdee0